import { render } from "./DatasetSummary.vue?vue&type=template&id=139aece0"
import script from "./DatasetSummary.vue?vue&type=script&lang=js"
export * from "./DatasetSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__